
import React from "react";
import "./Footer.css";
import {
  FaInstagram,
  FaTelegramPlane,
  FaWhatsapp,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaExternalLinkAlt,
} from "react-icons/fa";

export default function Footer({ navigateTo }) {
  const quickLinks = [
    { name: "صفحه اصلی", page: "shop", path: "/" },
    { name: "بلاگ", page: "blog-list", path: "/blog" },
    { name: "درباره ما", page: "about", path: "/about" },
    { name: "تماس با ما", page: "contact", path: "/contact" },
  ];

  const contactInfo = {
    email: "info.naghshekhial@gmail.com",
    phone: "09129518635",
    phoneDisplay: "0912-9518635",
    address: "تهران، میدان ونک، مرکز تجاری آسمان ونک",
  };

  const mapQuery = encodeURIComponent(contactInfo.address);
  const mapEmbedUrl = `https://www.google.com/maps?q=${mapQuery}&output=embed`;
  const mapOpenUrl = `https://www.google.com/maps/search/?api=1&query=${mapQuery}`;

  const socialLinks = [
    {
      name: "اینستاگرام",
      url: "https://www.instagram.com/naghshekhial_121",
      icon: FaInstagram,
      color: "#E4405F",
    },
    {
      name: "تلگرام",
      url: "https://t.me/naghshekhial_shop",
      icon: FaTelegramPlane,
      color: "#26A5E4",
    },
    {
      name: "واتساپ",
      url: "https://wa.me/989129518635",
      icon: FaWhatsapp,
      color: "#25D366",
    },
  ];

  const currentYear = new Date().getFullYear();

  const handleFooterNav = (page) => (e) => {
    if (!navigateTo) return;
    e.preventDefault();
    navigateTo(page);
  };

  return (
    <footer className="footer" dir="rtl">
      <div className="footer-container">
        <div className="footer-column footer-about">
          <h3 className="footer-logo">🎨 نقش خیال</h3>
          <p className="footer-description">
            فروشگاه تخصصی صنایع دستی سفالی و هنرهای سنتی؛ جایی برای انتخاب هدیه‌های خاص و
            دکوراسیون گرم و اصیل.
          </p>
          <span className="footer-badge">هنر ایرانی، برای خانه‌های اصیل ایرانی</span>
        </div>

        <div className="footer-column footer-links-col">
          <h4 className="footer-title">دسترسی سریع</h4>
          <ul className="footer-links">
            {quickLinks.map((link) => (
              <li key={link.name}>
                <a href={link.path} onClick={handleFooterNav(link.page)} className="footer-link">
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-column footer-contact-col">
          <h4 className="footer-title">تماس با ما</h4>

          <ul className="footer-contact">
            <li className="contact-item">
              <span className="contact-icon-wrap">
                <FaEnvelope className="contact-icon" />
              </span>
              <a href={`mailto:${contactInfo.email}`} className="contact-text ltr-text">
                {contactInfo.email}
              </a>
            </li>

            <li className="contact-item">
              <span className="contact-icon-wrap">
                <FaPhone className="contact-icon" />
              </span>
              <a href={`tel:${contactInfo.phone}`} className="contact-text ltr-text">
                {contactInfo.phoneDisplay}
              </a>
            </li>

            <li className="contact-item address-item">
              <span className="contact-icon-wrap">
                <FaMapMarkerAlt className="contact-icon" />
              </span>
              <span className="contact-text">{contactInfo.address}</span>
            </li>
          </ul>

          <div className="footer-map" aria-label="نقشه موقعیت نقش خیال">
            <iframe
              title="موقعیت فروشگاه نقش خیال روی نقشه"
              src={mapEmbedUrl}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            ></iframe>

            <a href={mapOpenUrl} target="_blank" rel="noopener noreferrer" className="map-open-link">
              مشاهده در Google Maps <FaExternalLinkAlt />
            </a>
          </div>
        </div>

        <div className="footer-column footer-social-col">
          <h4 className="footer-title">ما را دنبال کنید</h4>

          <div className="footer-socials">
            {socialLinks.map((social) => {
              const IconComponent = social.icon;

              return (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={social.name}
                  style={{ "--social-color": social.color }}
                >
                  <span className="social-icon-wrap">
                    <IconComponent className="social-icon" />
                  </span>
                  <span className="social-name">{social.name}</span>
                </a>
              );
            })}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="copyright">
            © {currentYear} تمامی حقوق برای فروشگاه <strong>نقش خیال</strong> محفوظ است.
          </p>

          <div className="developer-credit">
            <p>
              طراحی و توسعه وب‌سایت: <span>ناهید عبداله پور</span>
            </p>

            <a
              href="https://www.instagram.com/nahid.abdolahpour"
              target="_blank"
              rel="noopener noreferrer"
              className="developer-instagram"
              aria-label="اینستاگرام طراح وب‌سایت"
            >
              <FaInstagram />
              <span>nahid.abdolahpour</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}